import React, { useCallback, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { pushNotification } from "utils/notifications";
import ThuocTinhGiamTruApi from "service/ThuocTinhGiamTruApi";

const ThemSuaDongSanPham = ({ onClose, onSave, data, listCauHinhTaiSan, listHangSanXuat }) => {
    // console.log("Data: ", data);
    const [LoaiTaiSanID, setLoaiTaiSanID] = useState(data?.CauHinhTaiSanId ?? listCauHinhTaiSan[0]?.CauHinhTaiSanId);
    const [HangSanXuatID, setHangSanXuatID] = useState(data?.ThongTinGiamTruPID ?? listHangSanXuat[0]?.ThongTinGiamTruID);
    const [_listHangSanXuat, setlistHangSanXuat] = useState(listHangSanXuat ?? [])
    const [TenDongSanPham, setTenDongSanPham] = useState(data?.TenDongSanPham ?? "");
    const [saving, setSaving] = useState(false);
    const [errors, setErrors] = useState({});

    const loadListHangSanXuatbyCauHinhTaiSanID = async (id) => {
        const res = await ThuocTinhGiamTruApi.getListHangSanXuatByCauHinhTaiSanID({ id });
        setlistHangSanXuat(res.data || [])
        if (Array.isArray(res.data) && res.data.length > 0)
            setHangSanXuatID(res.data[0].ThongTinGiamTruID);
        else
            setHangSanXuatID(0);
    }

    const handleChangeLoaiTaiSan = (e) => {
        const newId = e.target.value;
        setLoaiTaiSanID(newId);
        loadListHangSanXuatbyCauHinhTaiSanID(newId);
    };
    const handleKeyDown = (event) => {
        if (event.key === "Escape") onClose();
    };
    useEffect(() => {
        document.addEventListener("keydown", handleKeyDown);
        return () => document.removeEventListener("keydown", handleKeyDown);
    }, []);
    const validate = () => {
        let newErrors = {};
        if (!TenDongSanPham.trim()) newErrors.TenDongSanPham = "Hãy nhập tên dòng sản phẩm";
        if (HangSanXuatID == 0) newErrors.HangSanXuatID = "Hãy chọn hãng sản xuất";
        return newErrors;
    };
    const handleSave = async () => {
        const newErrors = validate();
        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }
        setErrors({});
        setSaving(true);
        try {
            const payload = {
                ThongTinGiamTruID: data?.ThongTinGiamTruID ?? 0,
                ThongTinGiamTruPID: HangSanXuatID,
                LoaiTaiSanID: parseInt(LoaiTaiSanID),
                TenDongSanPham: TenDongSanPham,
                KeyThongTinGiamTru: data?.KeyThongTinGiamTru ?? "",
                isDel: data?.isDel ?? true
            };
            console.log("datasave payload: ", payload);
            await onSave(payload);
        }
        catch (err) {
            console.error("Lỗi khi lưu:", err);
            pushNotification("Có lỗi xảy ra khi lưu. Vui lòng thử lại.", "error", "TOP_CENTER", 1000);
        } finally {
            setSaving(false);
        }
    };

    return (
        <Modal
            show={true}
            size="lg"
            centered
            className="modal-new modal fade text-left"
            animation={true}
        >
            <Modal.Header>
                <h4 className="modal-title text-bold" style={{ paddingLeft: "15px" }}>
                    {(!data?.ThongTinGiamTruID || data.ThongTinGiamTruID === 0) ? "Thêm mới dòng sản phẩm" : "Sửa dòng sản phẩm"}
                </h4>
                <button type="button" className="close-popup-new" onClick={onClose}>
                    <i className="mdi mdi-close"></i>
                </button>
            </Modal.Header>
            <Modal.Body>
                <div className="row" style={{ paddingTop: "5px" }}>
                    <div className="col-md-6">
                        <div className="form-group">
                            <label><span className=" text-bold">Loại tài sản</span></label>
                            <select id="LoaiTaiSanID" name="LoaiTaiSanID"
                                value={LoaiTaiSanID}
                                onChange={handleChangeLoaiTaiSan}
                                className="form-control input-sm">
                                {listCauHinhTaiSan && listCauHinhTaiSan.map((cauhinh, index) => (
                                    <option key={index} value={cauhinh.CauHinhTaiSanId}>
                                        {cauhinh.TenHangHoa}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group">
                            <label><span className=" text-bold">Hãng sản xuất</span></label>
                            <select id="HangSanXuatID" name="HangSanXuatID"
                                value={HangSanXuatID}
                                onChange={(e) => setHangSanXuatID(e.target.value)}
                                className="form-control input-sm">
                                {_listHangSanXuat && _listHangSanXuat.map((hsx, index) => (
                                    <option key={index} value={hsx.ThongTinGiamTruID}>
                                        {hsx.TenHangSanXuat}
                                    </option>
                                ))}
                            </select>
                            {errors.HangSanXuatID && <div className="text-danger">{errors.HangSanXuatID}</div>}
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group">
                            <label><span className=" text-bold">Tên dòng sản phẩm</span><span className="text-danger">(*)</span></label>
                            <input
                                type="text"
                                className="form-control"
                                value={TenDongSanPham}
                                onChange={(e) => setTenDongSanPham(e.target.value)}
                            />
                            {errors.TenDongSanPham && <div className="text-danger">{errors.TenDongSanPham}</div>}
                        </div>
                    </div>
                </div>
            </Modal.Body>

            <Modal.Footer>
                <button className="btn btn-new-main btn-closenew" onClick={onClose} disabled={saving}>
                    <i className="mdi mdi-close"></i>&nbsp; Đóng
                </button>
                <button className="btn " onClick={handleSave} disabled={saving} style={{ background: "#056569", color: "white", borderRadius: "6px", fontSize: "15px", textTransform: "none" }}>
                    {saving ? (
                        <>
                            <span className="spinner-border spinner-border-sm"></span>&nbsp; Đang lưu...
                        </>
                    ) : (
                        <>
                            <i className="mdi mdi-content-save"></i>&nbsp; Lưu
                        </>
                    )}
                </button>
            </Modal.Footer>
        </Modal>
    );
}




export default ThemSuaDongSanPham;